<button
  ftrIconButton
  icon="Debug"
  size="large"
  ftrPopover
  [popoverContent]="popoverContent"
  popoverPreferredPosition="below"
  popoverPreferredAlignment="end"
  [popoverAllowAnchorDetach]="false"
>
  URL ID selector
</button>

<ng-template #popoverContent>
  <ftr-url-segments [segments]="segments()" (idSelected)="handleSelectedId($event)" />
</ng-template>
